import { RouteConfig } from "vue-router";
import { getLoginData } from "@/lib/authHelper";
import { enrichRouteMeta } from "@/router/helpers";

const routes: RouteConfig[] = [
  {
    path: "/",
    name: "index",
    component: () => import("@/views/PageLanding"),
  },
  {
    path: "/login",
    name: "login",
    component: () => import(/* webpackChunkName: "login/register" */ "@/views/PageLogin"),
  },
  {
    path: "/login/forgot",
    name: "loginForgot",
    component: () => import(/* webpackChunkName: "forgot password" */ "@/views/PageForgotPassword"),
  },
  {
    path: "/login/forgot/:email",
    name: "loginForgotEmail",
    component: () => import(/* webpackChunkName: "forgot password" */ "@/views/PageForgotPasswordConfirmCode"),
    props: true,
  },
  {
    path: "/login/forgot/:email/:token",
    name: "loginForgotSet",
    component: () => import(/* webpackChunkName: "forgot password" */ "@/views/PageForgotPasswordSet"),
    props: true,
  },
  {
    path: "/signup",
    name: "signup",
    component: () => import(/* webpackChunkName: "login/register" */ "@/views/PageSignUp"),
  },
  {
    path: "/signup/confirm",
    name: "signupConfirm",
    component: () => import(/* webpackChunkName: "signup confirm" */ "@/views/PageEmailConfirmCode"),
    props: route => ({ code: route.query.code }),
    beforeEnter(to, from, next) {
      const data = getLoginData();
      if (!data && !to.query.code) next(false);
      else next();
    },
  },
  {
    path: "/signup/email",
    name: "signupEmailConfirm",
    component: () => import(/* webpackChunkName: "signup confirm" */ "@/views/PageEmailConfirm"),
    meta: { private: true },
  },
  {
    path: "/login/twitter",
    name: "loginTwitter",
    component: () => import("@/views/PageLoginTwitter"),
    props: route => {
      return { queryString: route.query };
    },
  },
];

export default routes.map(route => enrichRouteMeta(route, { login: true }));
